import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
// components
import LoadingScreen from '../components/LoadingScreen';
import { useDispatch } from '../redux/store';
import { openModal } from '../redux/slices/authUiSlice';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();

  const dispatch = useDispatch();

  // const { pathname } = useLocation();

  // const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen loadable={true} />;
  }

  if (!isAuthenticated) {
    dispatch(
      openModal({
        view: 'login',
      })
    ); // open modal
    return <Navigate to="/" replace />;
  }

  // if (requestedLocation && pathname !== requestedLocation) {
  //   setRequestedLocation(null);
  //   return <Navigate to={requestedLocation} />;
  // }

  return <>{children}</>;
}
